import { useDroppable } from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { BoardEmptyColumn } from "./BoardEmptyColumn";
import type { BoardColumnProps } from "./types";

export function BoardColumn({ id, cardIds, children }: BoardColumnProps) {
  const { setNodeRef } = useDroppable({ id });

  return (
    <div ref={setNodeRef} className="flex flex-col shrink-0 min-h-0 h-full">
      <SortableContext items={cardIds} strategy={verticalListSortingStrategy}>
        <div className="flex flex-col gap-3 min-h-0 flex-1">
          {children}
          {cardIds.length === 0 && (
            <BoardEmptyColumn visible={cardIds.length === 0} />
          )}
        </div>
      </SortableContext>
    </div>
  );
}
